import React from 'react';
import DateFilter from 'reusable/datafilter';
import Search from 'reusable/search';
import SortBy from 'reusable/sortby';
import { useTranslation } from 'react-i18next';

interface ToolbarProps {
  searchValue: string;
  sortValue: string;
  dateValue: string;
  currentPage: number;
  onSearchChange: (value: string) => void;
  onSortChange: (value: string) => void;
  onDateChange: (value: string) => void;
  onPageChange: (value: number) => void;
}

const Toolbar: React.FC<ToolbarProps> = ({
  sortValue,
  dateValue,
  onSearchChange,
  onSortChange,
  onDateChange,
  onPageChange,
}) => {
  const { t } = useTranslation(['dashboard', 'common']);

  const sortingOptions = [
    { label: t('sort.default', { ns: 'common' }), value: '' },
    { label: t('sort.name', { ns: 'common' }), value: 'name' },
  ];
  const handleSortChange = (value: string) => {
    onSortChange(value);
    onPageChange(1);
  };

  const handleSearchChange = (value: string) => {
    onSearchChange(value);
    onPageChange(1);
  };

  const handleDateChange = (value: string) => {
    onDateChange(value);
    onPageChange(1);
  };

  return (
    <section className="flex flex-row justify-between w-10/12">
      <div className="flex w-2/5">
        <Search
          placeholder={t('table.search')}
          onSearchChange={handleSearchChange}
        />
      </div>
      <div className="flex flex-row space-x-4 items-center">
        <SortBy
          options={sortingOptions}
          defaultValue={sortValue}
          onChange={handleSortChange}
        />
        <DateFilter defaultDate={dateValue} onDateChange={handleDateChange} />
      </div>
    </section>
  );
};

export default Toolbar;
